import { render, staticRenderFns } from "./BaseInfoRemark.vue?vue&type=template&id=4f41009a"
import script from "./BaseInfoRemark.vue?vue&type=script&lang=js"
export * from "./BaseInfoRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports